import React, { useContext } from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import { DataContext } from '../../../../../context/DataContext';
import { PageContainer } from '../../../components/AdminContentWrapper';

/**
 * Gate de UI para pantallas root-only fuera del dominio de créditos
 * (equivalente a RequireBillingRole allow="root", pero sin el prop `allow`
 * porque acá siempre es root-only). El backend (billing-admin) ya autoriza
 * estrictamente por `cognito:groups` -- esto es solo para no renderizar un
 * formulario que de todos modos va a devolver 403.
 */
const RequireRootRole = ({ title, children }) => {
  const { isPlatformRoot } = useContext(DataContext);

  if (!isPlatformRoot) {
    return (
      <PageContainer title={title || 'Configuración de sistema'}>
        <Alert severity="warning">
          <AlertTitle>Acceso restringido</AlertTitle>
          Esta sección requiere el rol "root" (administrador de plataforma) en Cognito. Si
          crees que deberías tener acceso, contacta al administrador de tu cuenta.
        </Alert>
      </PageContainer>
    );
  }

  return <Box>{children}</Box>;
};

export default RequireRootRole;
